// Third party imports
import i18n from "i18n/config";

// "5 min ago" / "5 min fa", in the language of the app; older than a day: the date
export const formatTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const lang = i18n.resolvedLanguage || i18n.language || "it";
  const diffMinutes = Math.round((date - new Date()) / 60000);

  try {
    const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto", style: "short" });
    if (Math.abs(diffMinutes) < 60) return rtf.format(diffMinutes, "minute");
    const diffHours = Math.round(diffMinutes / 60);
    if (Math.abs(diffHours) < 24) return rtf.format(diffHours, "hour");
    return date.toLocaleDateString(lang);
  } catch {
    return date.toLocaleDateString();
  }
};
